/**
 * Configurazione globale dell'applicazione
 */

// API
export const API_CONFIG = {
    BASE_URL: '/sensori/api',
    ENDPOINTS: {
      SENSORS_LIST: 'getSensorsList.php',
      SENSOR_DATA: 'getSensorData.php',
      STATS_DATA: 'getStatsData.php'
    }
  };
  
  // Impostazioni sensori
  export const SENSOR_CONFIG = {
    // Mappatura dei tipi di sensori
    TYPES: {
      'Sensore1': 'regular',
      'Sensore2': 'regular',
      'Sensore3': 'regular',
      'Sensore4': 'regular',
      'Sensore5': 'weather',
      'Sensore6': 'regular',
      'Sensore7': 'regular',
      'Sensore8': 'regular',
      'Sensore9': 'regular',
      'Sensore10': 'regular',
      'Sensore11': 'regular',
      'Sensore12': 'regular',
      'Sensore13': 'regular',
      'Sensore14': 'regular',
      'Sensore15': 'regular',
      'SensoreLivello': 'level'
    },
    
    // Mappatura di nomi visualizzati predefiniti
    DEFAULT_NICKNAMES: {
        'Sensore5': 'Stazione Meteo',
        'SensoreLivello': 'Sensore Livello'
      },
    
    // Soglia per considerare un sensore inattivo (in minuti)
    INACTIVE_THRESHOLD: 30
  };
  
  // Impostazioni UI
  export const UI_CONFIG = {
    // Opzioni del periodo temporale
    TIME_RANGES: [
      { value: 'day', label: 'Ultime 24h' },
      { value: 'week', label: 'Ultima settimana' },
      { value: 'month', label: 'Ultimo mese' },
      { value: 'year', label: 'Ultimo anno' },
      { value: 'all', label: 'Tutti i dati' },
      { value: 'custom', label: 'Personalizzato' }
    ],
    
    // Opzioni di aggregazione
    AGGREGATION_OPTIONS: [
      { value: 'none', label: 'Nessuna' },
      { value: 'hourly', label: 'Oraria' },
      { value: 'daily', label: 'Giornaliera' }
    ],
    
    // Opzioni di refresh automatico
    REFRESH_INTERVALS: [
      { value: 10, label: '10 secondi' },
      { value: 30, label: '30 secondi' },
      { value: 60, label: '1 minuto' },
      { value: 300, label: '5 minuti' }
    ],
    
    // Limite dati predefinito
    DEFAULT_DATA_LIMIT: 500,
    
    // Metriche disponibili
    METRICS: [
      { id: 'temperatura', label: 'Temperatura', color: '#dc3545', unit: '°C' },
      { id: 'umidita', label: 'Umidità', color: '#0d6efd', unit: '%' },
      { id: 'livello', label: 'Livello', color: '#0dcaf0', unit: 'cm' },
      { id: 'pressure', label: 'Pressione', color: '#6c757d', unit: 'hPa' },
      { id: 'windSpeed', label: 'Velocità vento', color: '#20c997', unit: 'km/h' },
      { id: 'windDirection', label: 'Direzione vento', color: '#20c997', unit: '°' },
      { id: 'lightIntensity', label: 'Intensità luce', color: '#fd7e14', unit: 'lux' },
      { id: 'uvIndex', label: 'Indice UV', color: '#fd7e14', unit: '' },
      { id: 'rainGauge', label: 'Pioggia', color: '#0dcaf0', unit: 'mm' },
      { id: 'dewPoint', label: 'Punto di Rugiada', color: '#6610f2', unit: '°C' }
    ]
  };
  
  export default {
    API: API_CONFIG,
    SENSOR: SENSOR_CONFIG,
    UI: UI_CONFIG
  };